import {
  StyleSheet,
  Text,
  View,
  Image
} from '@react-pdf/renderer';

const styles = StyleSheet.create({

  title: {
    margin: '0 auto',
    paddingTop: 10,
    fontSize: 10,
    fontWeight: 700
  },
  description: {
    fontSize: 9,
    padding: 10,
    lineHeight: 1.3
  },

  agreeTermsBoxWrapper: {
    width: '70%',
    padding: 10,
    backgroundColor: '#add8e69e',
    margin: 10,
    position: 'absolute',
    bottom: 10,
    left: 5
  },
  checkboxImage: {
    width: 15,
    height: 15,
  },
  checkboxImagWithTextWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  textWrapper: {
    paddingLeft: 5
  },
  digitalSignatureBoxWrapper: {
    width: '100%',
    padding: 10,
    backgroundColor: '#fff',
    marginTop: 10,
  },
  descriptionTextWrapper: {
    marginBottom: 5
  }

});

const PdfAssignmentOfBenefit = (props) => {
  const {
    // eslint-disable-next-line react/prop-types
    name, insurer, signDate, signTime
  } = props;

  return (
    <>
      <View style={styles.title}>
        <Text>Assignment Of Benefits Form</Text>
      </View>
      <View>
        <View style={styles.descriptionTextWrapper}>
          <Text style={styles.description}>
            I, <Text style={{ fontWeight: 700 }}>{name}</Text> with insurance benefits through <Text style={{ fontWeight: 700 }}>{insurer},</Text>  hereby authorize benefits to be assigned to averhealth, for healthcare services provided to me by averhealth. I hereby certify that the insurance information that I have provided averhealth is true and accurate as of the date of service and that I am responsible for keeping it updated. I am fully aware that having health insurance does not absolve me of my responsibility to ensure that my medical bill is paid in full. I also understand that my insurance company may not pay 100% of the amount of the medical claim and I may be responsible for any and all amounts not payable by my insurance company including any portion paid and not applied to in network benefits for any out of network services.
          </Text>
        </View>
        <View style={styles.descriptionTextWrapper}>
          <Text style={styles.description}>
            I hereby irrevocably designate, authorize and appoint averhealth as my true and lawful attorney-in-fact. This power of attorney is hereby provided for the limited purpose of receiving all payments due under my policy/medical care plan on account of medical services and care rendered or to be rendered. This power of attorney shall automatically terminate, without formal action being taken, as soon as averhealth has received payment in full and remedies under applicable regulatory guidelines for all medical care services provided to patient. I hereby confirm and ratify all actions taken by my attorney-in-fact pursuant to the authority granted herein.
          </Text>
        </View>
        <View style={styles.descriptionTextWrapper}>
          <Text style={styles.description}>
            I hereby authorize my insurer to assign and transfer any and all applicable plan benefits and rights to averhealth and any appointed business associates working with them for the sole purpose of making sure all protected rights and entitled benefits under my specific plan are administered accurately, including the right to receive any applicable relevant, plan documents/remedies, disclosures, pursue appeals, administrative reviews and litigation on my behalf. This authorization includes any and all other rights permissible under state and federal laws, as well as entitled plan programs. This is a direct assignment of my rights and benefits under this plan/policy. This payment will not exceed my indebtedness to the above mentioned assignee, and I have agreed to pay, in a current manner, any balance of said professional service charges over and above this insurance payment. Upon receipt of said check, I authorize averhealth to receive any such checks, endorse them for deposit only, and to deposit and apply all the proceeds toward payment on my account. This authorization includes any and all rights permissible including all rights of appeal, disclosures, administrative reviews, litigation on my behalf and remedies due under any Title XVIII of the Social Security Act, related provisions of Title XI as well as Federal, City or State Government program. I hereby instruct and direct my Insurance Company to pay all entitled plan benefits at the stated plan benefit level directly to averhealth for all entitled benefits related to services rendered. I understand under applicable ERISA, state and/or federal regulatory guidelines that I have the right and authority to direct where payment for services rendered is sent. If my current policy prohibits direct payment to the provider of service, I under my rights per state and federal ERSIA regulations hereby instruct and direct my Insurance Company to provide SPD documentation stating such non-assign ability clause to myself and averhealth. Upon proof of non-assign ability documentation I then instruct that the insurer make out the check to me and mail it directly to averhealth at the address listed on the submitted claim for the professional or medical expense benefits, and otherwise payable to me under my current insurance policy as payment towards the total charges for the professional services rendered. I agree and understand that any funds received by my insurance company due for services rendered by averhealth will be immediately signed over and sent directly to averhealth. I authorize the release of any information pertinent to my case to any insurance company, adjuster, governmental agency or attorney involved in this case. I authorize averhealth or appointed business associates by averhealth to be my personal representative, which allows them as my legally binding authorized representative to: (1) submit any and all appeals when my insurance company denies me benefits to which I am entitled, (2) submit any and all requests for benefit information from my insurance company, and (3) initiate formal complaints to any State or Federal agency that has jurisdiction over my insurer and/or benefits. I fully understand and agree that I am responsible for full payment of the medical debt if my insurance company has refused to pay 100% of my stated plan benefits based on billed charges, within ninety (90) days of any and all appeals or request for information. Should the account be referred to an attorney or outside agency for collection, the undersigned shall pay reasonable attorney’s fees and collection expenses. All delinquent accounts bear interest at the legal rate. I also agree that any penalties or fines levied against my insurance company will be paid to averhealth for acting as my personal representative. I authorize averhealth to provide medical care reasonable and at the standard of care as required by state law. A photocopy of this Assignment shall be considered as effective and valid as the original.
          </Text>
        </View>

      </View>
      <View style={styles.agreeTermsBoxWrapper}>
        <View style={styles.checkboxImagWithTextWrapper}>
          <View style={styles.imageWrapper}>
            <Image
              style={styles.checkboxImage}
              src="assets/images/checkbox.png"
            />
          </View>
          <View style={styles.textWrapper}>
            <Text style={{ fontSize: 11 }}>
              I agree that I am {name} or their legal guardian.
            </Text>
          </View>
        </View>
        <View style={styles.checkboxImagWithTextWrapper}>
          <View style={styles.imageWrapper}>
            <Image
              style={styles.checkboxImage}
              src="assets/images/checkbox.png"
            />
          </View>
          <View style={styles.textWrapper}>
            <Text style={{ fontSize: 11 }}>
              I agree to the terms of Donor Agreement
            </Text>
          </View>
        </View>
        <View style={styles.digitalSignatureBoxWrapper}>
          <Text style={{ fontFamily: 'signature', fontSize: 20 }}>{name}</Text>
          <Text style={{ fontFamily: 'Opan Sans Italic' }}>Electronically Signed on {signDate} at {signTime}</Text>
        </View>
      </View>
    </>
  );
};

export default PdfAssignmentOfBenefit;
